export const API_ADMIN_USER = process.env.REACT_APP_API_MS_ADMINUSER_DEV
export const API_COLDEX = process.env.REACT_APP_API_MS_COLDEX_DEV
export const API_LOGYCA = process.env.REACT_APP_API_LOGYCA_DEV
export const API_RESOURCES = process.env.REACT_APP_API_MS_RESOURCE_DEV
export const API_REPORTS = process.env.REACT_APP_API_MS_REPORT
export const API_GATEWAY = process.env.REACT_APP_API_GATEWAY
export const URL_BASE_RESOURCES = process.env.REACT_APP_URL_BASE_RESOURCES 
export const URL_BASE_LANGUAGE = process.env.REACT_APP_URL_BASE_LANGUAGE
export const URL_REPORTS_STRIMLIB = process.env.REACT_APP_URL_REPORTS_STREAMLIT
export const URL_REPORT_POWER_BI = process.env.REACT_APP_URL_REPORT_POWER_BI
